import { useParams } from 'react-router-dom';

import { USER_TYPES } from 'shared_DEPRECATED/types/User';

import { ChatInterlocutorData } from 'features/chat/config/types/ChatInterlocutor';
import { useParticipantQuery } from 'features/participants/hooks';
import { useUserMode } from 'features/user/hooks';
import { useCoachQuery } from 'features/user/hooks/query/useCoach';

const getInterlocutor = (data?: ChatInterlocutorData) => {
  if (!data) {
    return null;
  }

  const name = data.name || data.email || data.userName || data.userEmail;
  const email = data.email || data.userEmail;
  const picture = data.picture || data.userPicture;

  return {
    name,
    picture,
    email,
    chatId: data.chatId,
    coachingStatus: data.coachingStatus,
  };
};

export default function useChatInterlocutorQuery(
  participantEmail?: string
) {
  const { email: routeEmail } = useParams();
  const userMode = useUserMode();

  // Use provided participantEmail if available, otherwise fallback to route param
  const email = participantEmail || routeEmail;

  const { participant, isLoading: isParticipantLoading } =
    useParticipantQuery(email);

  const { coach, isLoading: isCoachLoading } = useCoachQuery({
    enabled: userMode === USER_TYPES.USER,
  });

  return {
    chatInterlocutor:
      userMode === USER_TYPES.USER
        ? getInterlocutor(coach)
        : getInterlocutor(participant),
    isLoading: isParticipantLoading || isCoachLoading,
  };
}
